import React from "react";
import { Link } from "react-router-dom";

export const Informativos: React.FC = () => {

  return (
    <div className={"alert alert-info"}>
      {"Para entrar em contato conosco, favor enviar e-mail para: faelce@faelce.com.br ou utilize "}

      <Link className={"btn btn-primary"} to={"relacionamento"}>nossa central de atendimento</Link>
    </div>
  );
}
